import Swiper from 'swiper/bundle';
export default {
  init() {
    // JavaScript to be fired on the about us page
  },
  finalize() {

    jQuery(window).load(function(){     
   
  setTimeout(function(){

    var swiper = new Swiper('.swiper-container-post', {
      
      //spaceBetween: 10,
      loop: true,
      //centeredSlides: true,
      //loopedSlides: 3,
      autoplay: {
        delay: 3000,
      },
      breakpoints: {
        // when window width is >= 320px
        0: {
          slidesPerView: 1,
          spaceBetween: 0,

        },
        // when window width is >= 480px
       
        // when window width is >= 640px
        768: {
          slidesPerView: 'auto',
          spaceBetween: 0, 
        },
      },
    });
  swiper;



  },500);




  

 });
     

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/singleproject.js